<template>
  <div
    class="sb-collapsable-filter"
    :class="[
      `filter-${filter.key}`,
      isExpanded ? 'filter-expanded' : 'filter-collapsed'
    ]"
  >
    <div class="sb-filters-panel-header">
      <div class="filter-panel-title">
        <button
          class="filter-toggle-expand"
          @click="toggleIsExpanded"
        >
          <img
            alt="Expand / Collapse"
            :src="ChevronDownIcon"
            class="expand-icon-chevron"
            :class="isExpanded ? 'open' : 'closed'"
            :aria-expanded="true"
            :aria-label="$t('sbFilter.collapseRow')"
          >
        </button>
        <h3 class="filter-title">
          <sb-text :value="filter.name" />
        </h3>
      </div>
      <div>
        <SbButton
          variation="link"
          class="btn-reset text-uppercase"
          size="small"
          @click="handleReset"
        >
          <sb-text value="common.reset" />
        </SbButton>
        <slot name="remove-filter" />
      </div>
    </div>
    <div
      v-show="isExpanded"
      class="sb-filters-panel-body"
    >
      <component
        :is="formWidget"
        v-model:filter-value="internalValue"
        :version="dsComponentDetails.version"
        :filter="filter"
      />
    </div>
  </div>
</template>
<script>
import SbText from '@src/components/Text/SbText.vue';
import ChevronDownIcon from '@public/media/icons/chevron-down.svg';
import ChevronRightIcon from '@public/media/icons/chevron-right.svg';
import SbButton from '@src/components/Button/SbButton.vue';
import { versionedComponentsMixin } from '@src/mixins/versionedComponents';
// filter widgets
import FilterDropdown from '@src/components/Filter/components/collapsable/DropdownInput.vue';
import FilterTextInput from '@src/components/Filter/components/collapsable/TextInput.vue';
import FilterCheckboxInput from '@src/components/Filter/components/collapsable/CheckboxInput.vue';
import FilterRadioInput from '@src/components/Filter/components/collapsable/RadioInput.vue';
import CheckboxTree from '@src/components/Filter/components/collapsable/CheckboxTreeHandler.vue';
import DropdownChain from '@src/components/Filter/components/collapsable/DropdownChain.vue';
import DropdownSearch from '@src/components/Filter/components/collapsable/DropdownSearch.vue';
import Range from '@src/components/Filter/components/collapsable/Range.vue';

export default {
  name: 'SbCollapsableFilter',
  components: {
    SbButton,
    SbText,
    CheckboxTree,
  },
  mixins: [versionedComponentsMixin],
  props: {
    /**
     * the object containing filter name, key, options, etc
     */
    filter: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  emits: ['update-filter'],
  data: () => ({
    ChevronDownIcon,
    ChevronRightIcon,
    isExpanded: true,
    selectedOperator: '',
  }),
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        const update = {
          key: this.filter.key,
          value,
        };
        this.$emit('update-filter', update);
      },
    },
    formWidget() {
      const { type, component } = this.filter;
      if (component != null) return this.filter.component;
      switch (type) {
        case 'checkbox':
          return FilterCheckboxInput;
        case 'dropdown-chain':
          return DropdownChain;
        case 'checkbox-tree':
          return CheckboxTree;
        case 'range':
          return Range;
        case 'dropdown':
          return FilterDropdown;
        case 'dropdown-search':
          return DropdownSearch;
        case 'number':
          return FilterTextInput;
        case 'text':
          return FilterTextInput;
        case 'radio':
          return FilterRadioInput;
        default: return FilterTextInput;
      }
    },
  },
  methods: {
    toggleIsExpanded() {
      this.isExpanded = !this.isExpanded;
    },
    handleReset() {
      this.internalValue = {
        value: this.filter.default,
        operator: this.filter.defaultOperator,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
  @import '@src/components/Filter/style/sb-collapsable-filter.scss';
</style>
